import { translate } from '../../../../../common/i18n';
import theme from '../../theme';

Blockly.Blocks.set_max_steps = {
    init: function init() {
        this.appendValueInput('STEPS').setCheck('Number').appendField(translate('Set max step for virtual trades'));
        this.setInputsInline(false);
        this.setPreviousStatement(true, null);
        this.setNextStatement(true, null);
        this.setColour(theme.subBlockColor);
        this.setTooltip(translate('Sets the maximum step count of virtual trades'));
    },
    onchange: function onchange(ev) {
        const {
            childBlocks_,
            svgGroup_: { children },
        } = this;
        childBlocks_.map(a => {
            a.svgPath_.style.fill = theme.shadowDefault;
            a.svgPathDark_.style.display = 'none';
            return a;
        });
        for (let index = 0; index < children.length; index++) {
            const a = children[index];
            if (a.tagName === 'g' && a.classList.length === 0) {
                a.children[3].children[0].style.fill = theme.indicatorColorAccent;
                a.children[1].style.fill = theme.blockColor;
            } else if (a.tagName === 'g' && a.classList[0] === 'blocklyEditableText') {
                a.children[0].style.fill = theme.underBlockColor;
            } else if (a.tagName === 'g' && a.classList[0] === 'blocklyDraggable') {
                a.children[1].style.fill = theme.subBlockColor;
            }
        }
    },
};

Blockly.JavaScript.set_max_steps = block => {
    const steps = Blockly.JavaScript.valueToCode(block, 'STEPS', Blockly.JavaScript.ORDER_ATOMIC) || '0';
    return `BinaryBotPrivateVirtualSettings.maxSteps = ${steps};`;
};



// WEBPACK FOOTER //
// ./src/botPage/view/blockly/blocks/virtualtrades/setmaxsteps.js